/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Activitychart_Title1Inputs */

const zh_analytics_activitychart_title1 = /** @type {(inputs: Analytics_Activitychart_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每日活动`)
};

const en_analytics_activitychart_title1 = /** @type {(inputs: Analytics_Activitychart_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daily Activity`)
};

const es_analytics_activitychart_title1 = /** @type {(inputs: Analytics_Activitychart_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad diaria`)
};

/**
* | output |
* | --- |
* | "Daily Activity" |
*
* @param {Analytics_Activitychart_Title1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_activitychart_title1 = /** @type {((inputs?: Analytics_Activitychart_Title1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Activitychart_Title1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_activitychart_title1(inputs)
	if (locale === "en") return en_analytics_activitychart_title1(inputs)
	return es_analytics_activitychart_title1(inputs)
});
export { analytics_activitychart_title1 as "analytics_activityChart_title" }